export const PERSISTED_TABS_ID = 'TRADE_ALLOCATIONS' as const;
